import { Form } from 'factorial-form'

class Reports extends Form {
  constructor(values: object) {
    super(values, {
      type: 'string',
      kind: 'string',
      reference_date: 'date',
      daterange: 'string',
      from: 'date',
      to: 'date',
      leave_type_ids: 'any',
      employee_ids: 'any',
      employee_selection: 'any',
      trim_leave_duration: 'boolean',
    })
  }
}

export default Reports
